import { useEffect, useState } from "react";

/**
 * Tracks whether the window has scrolled past a threshold.
 * Returns `true` once window.scrollY > threshold.
 */
export function useScrolled(threshold = 12) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    // `onScroll` is declared inside the effect so it cannot be a dependency.
    // `setScrolled` from `useState` is referentially stable in React and is
    // safely omitted. Effect re-runs only when `threshold` changes.
    const onScroll = () => setScrolled(window.scrollY > threshold);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [threshold]);

  return scrolled;
}
